<template>
    <!-- Submitter Details Section -->
    <div v-if="!loggedPartner">
        <editable-text-field
            text-type="custom"
            :class="[
                'text-lg md:text-2xl font-semibold mb-4',
                 portalContentAndDesignStore.getPageContentTextColorClass
            ]"
            v-model="portalContentAndDesignStore.translationSettings.portal_translation_leads_who_is_submitting"
        />
        <!-- Name and Email Fields -->

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <!-- Name Field -->
            <div>
                <editable-text-field
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_name"
                    for-attribute="submitter_name"
                    class="block text-sm opacity-80 mb-1.5"
                    :class="portalContentAndDesignStore.getPageContentTextColorClass"
                    text-type="label"
                />
                <input type="text"
                    v-model="portalContentAndDesignStore.leadsFormData.submitter_name"
                    name="submitter_name"
                    id="submitter_name"
                    :class="portalContentAndDesignStore.getInputStyle"
                >
            </div>
            <!-- Email Field -->
            <div>
                <editable-text-field
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_email"
                    for-attribute="submitter_email"
                    class="block text-sm opacity-80 mb-1.5"
                    :class="portalContentAndDesignStore.getPageContentTextColorClass"
                    text-type="label"
                />
                <input
                    type="email"
                    v-model="portalContentAndDesignStore.leadsFormData.submitter_email"
                    name="submitter_email"
                    id="submitter_email"
                    :class="portalContentAndDesignStore.getInputStyle"
                >
            </div>
        </div>

        <div class="flex items-center justify-end mt-4">

            <editable-text-field
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_leads_already_have_account"
                for-attribute="already_have_account"
                :class="[
                    'text-sm mr-4',
                    portalContentAndDesignStore.getPageContentTextColorClass
                ]"
                text-type="span"
            />

            <modal :title="portalContentAndDesignStore.translationSettings.portal_translation_login_login"
                   size="simple"
                   ref="program_lead_login_modal"
                   field-class="text-gray-900"
            >
                <template #toggle>
                    <editable-btn
                        size="small"
                        :type="portalContentAndDesignStore.getPageContentButtonColorClass"
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_program_page_log_in"
                    />
                </template>
                <template #body>
                    <div class="space-y-4">

                        <div class="flex items-center bg-red-50 px-4 py-3 rounded text-red-500 text-sm gap-3 relative"
                             role="alert" v-if="errors.general_error">
                            <ul>
                                <li>{{ errors.general_error }}</li>
                            </ul>
                        </div>

                        <template v-if="portalContentAndDesignStore.leadsPageSettings.login_config?.otp_login">
                            <div>
                                <editable-text-field
                                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_email"
                                    for-attribute="otp_email"
                                    class="block text-sm opacity-80 mb-1.5"
                                    :class="portalContentAndDesignStore.getPageContentTextColorClass"
                                    text-type="label"
                                />
                                <input
                                    v-model="portalContentAndDesignStore.leadsPartnerLoginFormData.email"
                                    name="otp_email"
                                    id="otp_email"
                                    :class="portalContentAndDesignStore.getInputStyle"
                                >
                            </div>

                            <div>
                                <template v-if="portalContentAndDesignStore.leadsPartnerLoginFormData.otp.step === 2">
                                    <editable-text-field
                                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_OTP"
                                        for-attribute="otp_password"
                                        class="block text-sm opacity-80 mb-1.5"
                                        :class="portalContentAndDesignStore.getPageContentTextColorClass"
                                        text-type="label"
                                    />
                                    <input
                                        type="password"
                                        v-model="portalContentAndDesignStore.leadsPartnerLoginFormData.otp_token"
                                        id="otp_password"
                                        name="otp_password"
                                        :class="portalContentAndDesignStore.getInputStyle"
                                    >
                                </template>
                            </div>

                            <text-field
                                type="hidden"
                                v-model="portalContentAndDesignStore.leadsPartnerLoginFormData.otp_identifier"
                            ></text-field>
                        </template>
                        <template v-if="!portalContentAndDesignStore.leadsPageSettings.login_config?.otp_login">
                            <div>
                                <editable-text-field
                                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_email"
                                    for-attribute="email"
                                    class="block text-sm opacity-80 mb-1.5"
                                    :class="portalContentAndDesignStore.getPageContentTextColorClass"
                                    text-type="label"
                                />
                                <input
                                    type="email"
                                    v-model="portalContentAndDesignStore.leadsPartnerLoginFormData.email"
                                    name="email"
                                    id="email"
                                    :class="portalContentAndDesignStore.getInputStyle"
                                >
                            </div>

                            <div>
                                <editable-text-field
                                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_password"
                                    for-attribute="password"
                                    class="block text-sm opacity-80 mb-1.5"
                                    :class="portalContentAndDesignStore.getPageContentTextColorClass"
                                    text-type="label"
                                />
                                <input
                                    type="password"
                                    v-model="portalContentAndDesignStore.leadsPartnerLoginFormData.password"
                                    name="password"
                                    id="password"
                                    :class="portalContentAndDesignStore.getInputStyle"
                                >
                            </div>
                        </template>
                    </div>
                    <editable-btn
                        :prevent-double-click="5000"
                        size="large"
                        class="w-full mt-8"
                        :type="portalContentAndDesignStore.getPageContentButtonColorClass"
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_login"
                        @click.prevent="login"
                        :loading="loading.login"
                    />

                    <!-- Social Auth -->
                    <div v-if="portalContentAndDesignStore.leadsPageSettings.login_config?.social_login?.available">
                        <div class="flex flex-row items-center justify-center my-4">
                            <div class="w-full">
                                <hr>
                            </div>
                            <div class="px-4">
                                <editable-text-field
                                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_or"
                                    class="block text-sm opacity-80 mb-1.5"
                                    :class="portalContentAndDesignStore.getPageContentTextColorClass"
                                    text-type="span"
                                >
                                </editable-text-field>
                            </div>
                            <div class="w-full">
                                <hr>
                            </div>
                        </div>

                        <editable-social-auth-btn
                            social-provider="google"
                            context="program_lead_login"
                            :social-submit-url="portalContentAndDesignStore.getSocialAuthLoginRedirectRoute('google')"
                            v-model="portalContentAndDesignStore.leadsPageSettings.login_config.social_login.texts.login_with_google"
                        />
                    </div>
                </template>
            </modal>
        </div>
        <!-- Login Button -->
    </div>

    <div class="flex justify-between items-center space-x-4" v-else>
        <div class="flex space-x-1.5">
            <editable-text-field
                :class="[
                    'text-sm inline-block',
                     portalContentAndDesignStore.getPageContentTextColorClass
                 ]"
                text-type="span"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_leads_logged_in"
            ></editable-text-field>

            <span class="inline-block font-semibold">{{ loggedPartner.name }}</span>
        </div>
        <div>
            <editable-btn
                :prevent-double-click="5000"
                size="small"
                :type="portalContentAndDesignStore.getPageContentButtonColorClass"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_leads_log_out"
                @click.prevent="logout"
                :loading="loading.logout"
            />
        </div>
    </div>

</template>

<script setup>

import {ref, computed} from 'vue';
import Modal from "../../../elements/Modal.vue";
import TextField from "../../../elements/forms/TextField.vue";
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import EditableTextField from "../portal-editable-fields/EditableTextField.vue";
import EditableBtn from "../portal-editable-fields/EditableBtn.vue";
import EditableSocialAuthBtn from "../portal-editable-fields/EditableSocialAuthBtn.vue";

const props = defineProps({
    loggedPartner: {
        type: [Object, null],
        default: null,
    },
});

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const program_lead_login_modal = ref(null);
const loggedPartner = ref(props.loggedPartner);

const loading = ref({
    login: false,
    logout: false,
});

const errors = ref({
    otp_email: null,
    otp_token: null,
    submitter_name: null,
    submitter_email: null,
    general_error: null
});

const login = () => {

    if (portalContentAndDesignStore.leadsPageSettings.login_config?.otp_login) {
        return otpLogin();
    }

    return simpleLogin();
}

const logout = () => {
    if (loading.value.logout === true) {
        return;
    }

    loading.value.logout = true;

    axios.post(route('partners.leads.login.logout'))
        .then(response => {
            const status = parseInt(response.data.status ?? -1);
            if (status === 1) {

                loggedPartner.value = null;
            }
        }).finally(() => loading.value.logout = false);

    return true;
}

const simpleLogin = () => {

    if (loading.value.login === true) {
        return;
    }

    loading.value.login = true;
    errors.value.general_error = null;

    axios.post(route('partners.leads.login.login'), {
        email: portalContentAndDesignStore.leadsPartnerLoginFormData.email,
        password: portalContentAndDesignStore.leadsPartnerLoginFormData.password,
    }).then(response => {
        const status = parseInt(response.data.status ?? -1);
        if (status === 1) {

            program_lead_login_modal.value.onCancel();

            portalContentAndDesignStore.leadsPartnerLoginFormData.email = null;
            portalContentAndDesignStore.leadsPartnerLoginFormData.password = null;

            loggedPartner.value = response.data.logged_partner;
        } else {
            errors.value.general_error = 'Account not found or bad credentials';
        }
    }).finally(() => loading.value.login = false);

    return true;
}

const otpLogin = () => {

    if (loading.value.login === true) {
        return;
    }

    loading.value.login = true;
    errors.value.general_error = null;

    if (portalContentAndDesignStore.leadsPartnerLoginFormData.otp.step === 1) {
        axios.post(route('partners.leads.login.otp_ini'), {
            email: portalContentAndDesignStore.leadsPartnerLoginFormData.email,
        }).then(response => {
            const status = parseInt(response.data.status ?? -1);
            if (status === 1) {
                portalContentAndDesignStore.leadsPartnerLoginFormData.otp_identifier = response.data.otp_identifier;
                portalContentAndDesignStore.leadsPartnerLoginFormData.otp.step = 2;
            }

            if (status === 0) {
                errors.value.general_error = response.data?.error ?? 'Account not found or bad credentials';
            }
        }).finally(() => loading.value.login = false);
    }

    if (portalContentAndDesignStore.leadsPartnerLoginFormData.otp.step === 2) {
        axios.post(route('partners.leads.login.login'), {
            otp_token: portalContentAndDesignStore.leadsPartnerLoginFormData.otp_token,
            otp_identifier: portalContentAndDesignStore.leadsPartnerLoginFormData.otp_identifier,
        }).then(response => {
            const status = parseInt(response.data.status ?? -1);
            if (status === 1) {

                program_lead_login_modal.value.onCancel();

                portalContentAndDesignStore.leadsPartnerLoginFormData.otp.step = 1;
                portalContentAndDesignStore.leadsPartnerLoginFormData.email = null;
                portalContentAndDesignStore.leadsPartnerLoginFormData.otp_identifier = null;
                portalContentAndDesignStore.leadsPartnerLoginFormData.otp_identifier = null;

                loggedPartner.value = response.data.logged_partner;
            } else {
                errors.value.general_error = 'Account not found or bad credentials';
            }
        }).finally(() => loading.value.login = false);
    }

    return true;
}

</script>
